
namespace Serenity {
    
    export interface AutoColumnWidthMixinOptions {
		grid: Serenity.DataGrid<any, any>;
		/** If column has an explicit width set in Form.cs, use that width on auto size, doesn't effect manually triggered auto size */
		useExplicitWidths?: () => boolean;
		/** Set to true if headers shouldn't affect auto width, default is false */
		ignoreHeaders?: boolean;
		/** Maximum rows to scan in data source, default is 40*/
		maxRows?: number;
		/** Maximum column width, default value is 400 */
		maxWidth?: number;
		/** Minimum column width, default value is 30 */
		minWidth?: number;
        /** Callback used before user auto size all columns */
        beforeUserAutoSizeAll?: () => void;
        /** Callback used after user auto size all columns */
        afterUserAutoSizeAll?: () => void;
    }

    /**
     * A mixin that can be applied to a DataGrid for auto size column width functionality
     */
	export class AutoColumnWidthMixin extends Serenity.Widget<AutoColumnWidthMixinOptions> {

		private slickGrid: Slick.Grid;
        private $container: JQuery;
        public autoSizingAll: number = 0;

		constructor(options: AutoColumnWidthMixinOptions) {
			super(options.grid.element, options);

			this.slickGrid = options.grid.slickGrid;
			this.$container = $((this.slickGrid as any).getContainerNode());

			this.$container.on('dblclick.' + this.uniqueName, '.slick-resizable-handle', (e) => this.resizeHandleClick(e));
		}

		destroy() {
			if (this.options && this.options.grid) {
				this.options.grid.element.off('.' + this.uniqueName);
			}

			this.options = null;
			this.slickGrid = null;
			this.$container = null;
			super.destroy();
		}

		private resizeHandleClick(e: JQueryEventObject) {
			if (e.ctrlKey) {
				e.preventDefault();
				e.stopPropagation();
                this.options.beforeUserAutoSizeAll && this.options.beforeUserAutoSizeAll();
				this.autoSizeAllColumns(false);
                this.options.afterUserAutoSizeAll && this.options.afterUserAutoSizeAll();
				return;
			}

			var $header = $(e.currentTarget).closest('.slick-header-column');
			var columnDef = $header.data('column') as Slick.Column;

			if (!columnDef || !columnDef.resizable)
				return;

			e.preventDefault();
			e.stopPropagation();

			this.autoSizeColumn($header, columnDef);
		}

		private getAutoColumnWidth($header: JQuery, columnDef: Slick.Column) {
			var colIndex = this.slickGrid.getColumnIndex(columnDef.id);

			var autoWidth = this.getMaxColumnWidth(columnDef, colIndex);
                        var ele: any = $header[0];
			if (!this.options.ignoreHeaders) {
				autoWidth = Math.max(getElementWidth(ele), autoWidth);
			}

			autoWidth = (autoWidth || 0) + 1;

			if (columnDef.maxWidth > 0)
				autoWidth = Math.min(autoWidth, columnDef.maxWidth);
			else
				autoWidth = Math.min(autoWidth, this.options.maxWidth || 400);

			if (columnDef.minWidth > 0)
				autoWidth = Math.max(autoWidth, columnDef.minWidth);
			else
				autoWidth = Math.max(autoWidth, this.options.minWidth || 30);

			return autoWidth;
		}

		private autoSizeColumn($header: JQuery, columnDef: Slick.Column) {
			var autoWidth = this.getAutoColumnWidth($header, columnDef);

			if (autoWidth !== columnDef.width) {
				columnDef.width = autoWidth;
				this.slickGrid.setColumns(this.slickGrid.getColumns());
				this.slickGrid.onColumnsResized.notify();
			}
		}

        private queueAutoSize: number = 0;

        public autoSizeAllColumns(useExplicitWidths?: boolean) {
            if (!this.$container.is(':visible')) {
                
                if (this.queueAutoSize <= 0) {
                    this.queueAutoSize++;
                    LazyLoadHelper.executeOnceWhenShown(this.$container, () => this.autoSizeAllColumns(useExplicitWidths));
                }

                return;
            }

            if (this.queueAutoSize > 0) {
                this.queueAutoSize--;
            }

            this.autoSizingAll++;
            try {

                var $headers = this.$container.find(".slick-header-column");
                useExplicitWidths = Q.coalesce(useExplicitWidths, this.options.useExplicitWidths && this.options.useExplicitWidths());
                $headers.each((index, el) => {
                    var columnDef = $(el).data('column') as Slick.Column;
                    if (!columnDef)
                        return;
                    var autoWidth = (useExplicitWidths && columnDef.sourceItem && columnDef.sourceItem.width > 0 && columnDef.sourceItem.widthSet) ?
                        columnDef.sourceItem.width : this.getAutoColumnWidth($(el), columnDef);
                    columnDef.width = autoWidth;
                });

                this.slickGrid.setColumns(this.slickGrid.getColumns());
                this.slickGrid.onColumnsResized.notify();
            }
            finally {
                this.autoSizingAll--;
            }
		}

		private createRow(columnDef: Slick.Column) {
			var rowEl = $('<div class="slick-row"><div class="slick-cell" style="text-overflow: initial; white-space: nowrap;"></div></div>');
			var gridCanvas = this.slickGrid.getCanvasNode();
			$(gridCanvas).append(rowEl);
			return rowEl;
		}

		private getMaxColumnWidth(columnDef: Slick.Column, colIndex: number) {
			var rowEl = this.createRow(columnDef);
			var maxAllowedWidth = columnDef.maxWidth > 0 ? columnDef.maxWidth : this.options.maxWidth;
			try {
				var cell: any = rowEl.children()[0];

				var length = this.slickGrid.getDataLength();
				if ((this.options.maxRows ?? 40) < length)
					length = this.options.maxRows ?? 40;

                var maxWidth = 0;
                var offset = 0;
				for (var i = 0; i < length; i++) {
					var item = this.slickGrid.getDataItem(i);

					if (columnDef.formatter) {
						try {
							var html = columnDef.formatter(-1, colIndex, item[columnDef.field], columnDef, item);
							cell.innerHTML = html;
						}
						catch(ex) {
							cell.innerText = Q.coalesce(item[columnDef.field], '');
                        }

                        var child = cell.childNodes[0] as HTMLElement;
                        if (child && child.tagName == "INPUT" &&
                            (child as HTMLInputElement).type != "checkbox") {
                            var cs = getComputedStyle(child);
                            offset = (parseFloat(cs.borderLeftWidth) || 0) +
                                (parseFloat(cs.borderRightWidth) || 0) +
                                (parseFloat(cs.paddingLeft) || 0) +
                                (parseFloat(cs.paddingRight) || 0); 
                            cell.innerText = (child as HTMLInputElement).value;
                        }
					}
					else
						cell.innerText = Q.coalesce(item[columnDef.field], '');

                    var width = cell.offsetWidth + offset;
					if (width > maxWidth)
						maxWidth = width;

					if (maxAllowedWidth > 0 && width >= maxAllowedWidth)
						break;
				}

				return maxWidth || 0;
			}
			finally {
				rowEl.remove();
			}
		}
	}

	function getElementWidth(element: HTMLElement) {
		var width, clone = element.cloneNode(true) as HTMLElement;
		clone.style.cssText = 'position: absolute; visibility: hidden; right: auto; text-overflow: initial; white-space: nowrap;';
		element.parentNode.insertBefore(clone, element);
		width = clone.offsetWidth;
		clone.parentNode.removeChild(clone);
		return width;
	}

	
}